<app-dialog-container class="fullscreen-dialog">
    <div class="dialog-content" fxLayout="column" fxLayoutAlign="start stretch">
        <!-- Header com título e ações -->
        <div class="dialog-header" fxLayout="row"
            fxLayoutAlign="space-between center" fxLayoutGap="16px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                <mat-icon class="header-icon">description</mat-icon>
                <h2 mat-dialog-title class="no-margin">Pré-visualização do
                    Contrato</h2>
            </div>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
                <button mat-flat-button color="primary" class="generate-button"
                    (click)="confirm()" [disabled]="loading || error"
                    matTooltip="Gerar contrato oficial"
                    fxLayout="row" fxLayoutAlign="center center"
                    fxLayoutGap="8px">
                    <mat-icon>check_circle</mat-icon>
                    <span>GERAR CONTRATO</span>
                </button>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Barra de ações do PDF 
        <div *ngIf="pdfUrl && !loading && !error" class="pdf-toolbar"
            fxLayout="row"
            fxLayoutAlign="end center" fxLayoutGap="8px">
            <button mat-button color="primary" (click)="openPdfInNewTab()">
                <mat-icon>open_in_new</mat-icon> Abrir em nova aba
            </button>
            <button mat-button color="primary" (click)="downloadPdf()">
                <mat-icon>download</mat-icon> Baixar PDF
            </button>
        </div>
        -->

        <!-- Conteúdo do PDF -->
        <div class="pdf-container" fxFlex fxLayout="column"
            fxLayoutAlign="center center">
            <!-- Loading State -->
            <div *ngIf="loading" class="loading-state" fxLayout="column"
                fxLayoutAlign="center center" fxLayoutGap="16px">
                <mat-spinner diameter="48"></mat-spinner>
                <div fxLayout="column" fxLayoutAlign="center center"
                    fxLayoutGap="8px">
                    <h3 class="loading-title">Gerando prévia do contrato</h3>
                    <p class="loading-subtitle">Isso pode levar alguns
                        segundos...</p>
                </div>
            </div>

            <!-- PDF Viewer -->
            <div *ngIf="pdfUrl && !loading && !error" class="pdf-wrapper"
                fxFlex>
                <!-- Uso de iframe direto como primeira opção para melhor compatibilidade -->
                <iframe [src]="pdfUrl" class="pdf-iframe"
                    frameborder="0"></iframe>

                <!-- Object como fallback registrado para referência -->
                <object #pdfViewer [attr.data]="pdfUrl" type="application/pdf"
                    class="pdf-viewer-object" style="display: none;">
                </object>

                <!-- Barra de ajuda - mostrada quando o PDF não carrega corretamente -->
                <div *ngIf="showHelp" class="pdf-fallback-actions"
                    fxLayout="row"
                    fxLayoutAlign="center center" fxLayoutGap="16px">
                    <p>Problemas para visualizar o contrato?</p>
                    <button mat-raised-button color="primary"
                        (click)="openPdfInNewTab()">
                        <mat-icon>open_in_new</mat-icon> Abrir em nova aba
                    </button>
                    <button mat-raised-button color="accent"
                        (click)="downloadPdf()">
                        <mat-icon>download</mat-icon> Baixar PDF
                    </button>
                </div>
            </div>

            <!-- Error State -->
            <div *ngIf="!loading && error" class="error-state"
                fxLayout="column" fxLayoutAlign="center center"
                fxLayoutGap="16px">
                <mat-icon class="error-icon">error_outline</mat-icon>
                <div fxLayout="column" fxLayoutAlign="center center">
                    <h3 class="error-title">Erro ao gerar prévia do
                        contrato</h3>
                    <p class="error-subtitle">{{ errorMessage ||
                        'Não foi possível gerar a prévia do documento.' }}</p>
                    <button mat-flat-button color="primary"
                        (click)="loadPreview()">
                        <mat-icon>refresh</mat-icon>
                        Tentar novamente
                    </button>
                </div>
            </div>
        </div>
    </div>
</app-dialog-container>